import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { AlertCircleOutline } from '@opengov/react-capital-assets';
import React from 'react';
import { styles } from './DeletedGroupColumnHeader.styles';

const intl = {
  text: 'This group has been deleted',
  tooltip: "Update this column's configuration to remove this warning."
};

export function DeletedGroupColumnHeader() {
  return (
    <Box sx={styles.root}>
      <Tooltip title={intl.tooltip} placement="top">
        <Box sx={styles.iconWrapper}>
          <SvgIcon component={AlertCircleOutline} inheritViewBox fontSize="small" sx={styles.icon} />
        </Box>
      </Tooltip>
      <Typography variant="body2" sx={styles.text}>
        {intl.text}
      </Typography>
    </Box>
  );
}
